// import { X, Send, Mic, Headset, User } from 'lucide-react';
import Icons_Repository from '../Icons/Icons_Repository';
import { useState, useEffect, useRef } from 'react';
import './Main_Navigation_ChatCopilot.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { WebSocketService, Message, ConnectionStatus } from '../Services/WebsocketService';
import ApiServiceAuth from '../Services/ApiService_auth';
 
interface ChatCopilotProps {
  isOpen: boolean;
  onClose: () => void;
  iconImage: string;
  userType?: 'recruiter' | 'interviewer';
  candidateEmail: string;
}

function getBaseDomain(): string {
  const hostname = window.location.hostname;

  if (hostname.includes('localhost')) {
    return 'http://localhost:5000';
  } else if (hostname.includes('dev')) {
    return 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    return 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    return 'https://candidateinterviewscheduler.pwc.com'; // fallback production
  }
}

 
function ChatCopilot({ isOpen, onClose, iconImage, userType = 'recruiter', candidateEmail }: ChatCopilotProps) {
 
  const [messages, setMessages] = useState<Message[]>([]);
  const [inputValue, setInputValue] = useState('');
  const [connectionStatus, setConnectionStatus] = useState<ConnectionStatus>('disconnected');
  const [isTyping, setIsTyping] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState<string>('');
  const authServices = ApiServiceAuth
  const wsServiceRef = useRef<WebSocketService | null>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const clickedClose = useRef(false);
 
 
  
   useEffect(() => {
  if (isOpen && !wsServiceRef.current) {
    clickedClose.current = false;  // Reset when opening
   
    //Get user session details
    const userData = authServices.getUserSession()
    const userId = userData?.user_id || 'unknown'
    const profileName = `${userData?.first_name} ${userData?.last_name}`
    const userEmail = userData?.email
    const role = userData?.role
    const roleType = userData?.role_type

   const baseDomain = getBaseDomain();
 
    // Initialize WebSocket service
   const wsService = new WebSocketService({
    wsUrl: `${baseDomain.startsWith('https') ? 'wss' : 'ws'}://${baseDomain.replace(/^https?:\/\//, '')}/ws/chat`,
    apiUrl: baseDomain,
    userId: userId,
    profileName: profileName,
    userEmail: candidateEmail,
    role: role,
    roleType: roleType
  });

  
  
 
    // Set up event handlers
    wsService.onMessage((message) => {
      setMessages(prev => [...prev, message]);
    });
 
    wsService.onStatusChange((status) => {
      setConnectionStatus(status);
    });
 
    wsService.onTypingChange((typing) => {
      setIsTyping(typing);
    });
 
    wsService.onErrorHandler((error) => {
      console.error('WebSocket error:', error);
    });
 
    wsService.onSessionChange((newSessionId) => {
      setCurrentSessionId(newSessionId);
      console.log('Session changed to:', newSessionId);
    });
 
    // Get the generated session ID for display
    const sessionId = wsService.getSessionId();
    if (sessionId) {
      setCurrentSessionId(sessionId);
    }
 
    // Connect
    wsService.connect();
    wsServiceRef.current = wsService;
   
  } else if (!isOpen) {
    clickedClose.current = true;
    setMessages([]);
    setIsTyping(false);
    setInputValue('');
   
    if (wsServiceRef.current) {
      wsServiceRef.current.disconnect();
      wsServiceRef.current = null;
    }
  }
 
  return () => {
    if (clickedClose.current && wsServiceRef.current) {
      wsServiceRef.current.disconnect();
      wsServiceRef.current = null;
    }
  };
}, [isOpen]);
 
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);
 
  const handleSendMessage = () => {
    if (!inputValue.trim() || !wsServiceRef.current) return;
   
    wsServiceRef.current.sendMessage(inputValue);
    setInputValue('');
  };
 
  const handleSuggestedAction = (action: string) => {
    if (!wsServiceRef.current) return;
   
    wsServiceRef.current.sendMessage(action);
  };
 
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
 
  const handleRefresh = () => {
  setMessages([]);
  setInputValue('');
  setIsTyping(false);
  
  // Optionally reconnect websocket with new session
  if (wsServiceRef.current) {
    wsServiceRef.current.disconnect();
    wsServiceRef.current = null;
  }
  
  // Trigger reconnection
  if (isOpen) {
    const userData = authServices.getUserSession()
    const userId = userData?.user_id || 'unknown'
    const profileName = `${userData?.first_name} ${userData?.last_name}`
    const userEmail = userData?.email
    const role = userData?.role
    const roleType = userData?.role_type

    const baseDomain = getBaseDomain();
 
    const wsService = new WebSocketService({
      wsUrl: `${baseDomain.startsWith('https') ? 'wss' : 'ws'}://${baseDomain.replace(/^https?:\/\//, '')}/ws/chat`,
      apiUrl: baseDomain,
      userId: userId,
      profileName: profileName,
      userEmail: candidateEmail,
      role: role,
      roleType: roleType
    });
 
    wsService.onMessage((message) => {
      setMessages(prev => [...prev, message]);
    });
 
    wsService.onStatusChange((status) => {
      setConnectionStatus(status);
    });
 
    wsService.onTypingChange((typing) => {
      setIsTyping(typing);
    });
 
    wsService.onErrorHandler((error) => {
      console.error('WebSocket error:', error);
    });
 
    wsService.onSessionChange((newSessionId) => {
      setCurrentSessionId(newSessionId);
    });

    wsService.connect();
    wsServiceRef.current = wsService;
  }
};
  if (!isOpen) return null;
 
    const chatOptions =
    [
      'Select interview slots',
      'Reschedule my interview',
      'Withdraw my application',
      'Ask recruiter'
    ]

  return (
    <>
      {isOpen && (
        <div className="blur-overlay" />
      )}
      <div className="chat-copilot-container">
        {/* Chat Header */}
        <div className="chat-header">
          <div className="chat-header-left">

            {/* <div className="chat-logo"> */}
              {/* <img
                src={iconImage}
                alt="Ask me"
                className="chat-logo-image"
              /> */}
            {/* </div> */}
            <div className="chat-title-wrapper">
              <h3 className="chat-title">AI Agent Assist</h3>
            </div>
          </div>
  
          <div className="chat-header-right">
            <button
              onClick={handleRefresh}
              className="chat-refresh-button"
              aria-label="Refresh chat"
            >
              <Icons_Repository iconName="refresh" />
            </button>
            <button
              onClick={onClose}
              className="chat-close-button"
            >
              <Icons_Repository iconName="x" />
            </button>
          </div>
        </div>
        {/* Chat Content */}
  
        {/* Welcome message only shown when no messages */}
    
    
      <div className="chat-content">
        {/* Welcome message only shown when no messages */}
        {messages.length === 0 && (
          <div className="chat-message assistant">
            <div className="message-avatar">
              <Icons_Repository iconName="headset" />
            </div>
            <div className="message-bubble">
              <p>Hi, what can I assist you with today?</p>
              <span className="message-time">
                {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
          </div>
        )}
  
        {/* Chat options always at top - stays visible */}
        <div className="chat-options">
          {chatOptions.map((option, index) => (
            <button
              key={index}
              className="chat-option-button"
              onClick={() => handleSuggestedAction(option)}
            >
              {option}
            </button>
          ))}
        </div>
  
        {/* All conversation messages */}
  
  
        {/* Welcome message only shown when no messages */}
  
  
        {/* All conversation messages */}
        {messages.map((message) => (
          <div key={message.id} className={`chat-message ${message.isUser ? 'user' : 'assistant'}`}>
            {!message.isUser && (
              <div className="message-avatar">
              <Icons_Repository iconName="headset" />
              </div>
            )}
            <div className="message-bubble">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  p: ({children}) => <p>{children}</p>,
                  strong: ({children}) => <strong>{children}</strong>,
                  em: ({children}) => <em>{children}</em>,
                
                  // Tables
                  table: ({ children }) => (
                    <div className="markdown-table-wrapper">
                      <table className="markdown-table">{children}</table>
                    </div>
                  ),
                  thead: ({ children }) => <thead className="markdown-table-head">{children}</thead>,
                  tbody: ({ children }) => <tbody className="markdown-table-body">{children}</tbody>,
                  tr: ({ children }) => <tr className="markdown-table-row">{children}</tr>,
                  th: ({ children }) => <th className="markdown-table-header">{children}</th>,
                  td: ({ children }) => <td className="markdown-table-cell">{children}</td>,
                
                  // Lists
                  ol: ({ children }) => <ol className="markdown-ordered-list">{children}</ol>,
                  ul: ({ children }) => <ul className="markdown-unordered-list">{children}</ul>,
                  li: ({ children }) => <li className="markdown-list-item">{children}</li>,
                
                  // Code
                  code: ({children}) => <code className="markdown-code">{children}</code>,
                
                  // Links
                  a: ({href, children}) => (
                    <a
                      href={href}
                      className="markdown-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {children}
                    </a>
                  ),
                }}
              >
                {message.content}
              </ReactMarkdown>
              <span className="message-time">
                {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
            {message.isUser && (
              <div className="message-avatar user-avatar">
                <Icons_Repository iconName="user" />
              </div>
            )}
          </div>
        ))}
  
        {/* Enhanced Typing indicator */}
        {isTyping && (
          <div className="chat-message assistant">
            <div className="message-avatar">
              <Icons_Repository iconName="headset" />
            </div>
            <div className="message-bubble typing">
              <div className="typing-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        )}
      <div ref={messagesEndRef} />
      </div>
  
        {/* Chat Input */}
        <div className="chat-input-container">
          <div className="chat-input-wrapper">
            {/* <button className="chat-mic-button" aria-label="Voice input"> */}
              {/* <Icons_Repository iconName="mic" /> */}
            {/* </button> */}
            <input
              type="text"
              placeholder="Ask me anything..."
              className="chat-text-input"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={connectionStatus !== 'connected'}
            />
            <button
            className="chat-send-button"
            aria-label="Send message"
            onClick={handleSendMessage}
            disabled={!inputValue.trim() || connectionStatus !== 'connected'}
            >
              <Icons_Repository iconName="send" />
            </button>
          </div>

          {/* Disclaimer */}
          <div className="chat-disclaimer">
            <p>
              AI-generated content may be inaccurate and requires human review.{' '}
              <a 
                href="https://hq.pwc.com/content/hq/en/our-clients-and-business/delivering-one-firm-to-clients/artificial-intelligence-at-pwc/business-rules-for-use-of-generative-ai.html"
                target="_blank"
                rel="noopener noreferrer"
                className="disclaimer-link"
              >
                GenAI Business Rules
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
 
export default ChatCopilot;
 